import React from 'react';
import DeviceIconSVG from '../DeviceIconSVG';
import { DeviceIconSVGType } from '../models';

const SecurityCamera: DeviceIconSVGType = ({ accentColor }) => (
  <DeviceIconSVG width="41" height="61" viewBox="0 0 41 61" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="black"
      d="M26.6678 59.1813V48.2824C32.2477 46.3487 36.2669 40.982 36.2771 34.6846V15.2753C36.2669 7.35445 29.8913 0.891602 22.0773 0.891602H18.4866C10.6727 0.891602 4.2971 7.35445 4.2869 15.2753V34.6846C4.2971 40.982 8.31627 46.3487 13.8962 48.2824V59.1813H0.390137V60.7324H40.1738V59.1813H26.6678ZM15.4263 58.9228V49.0683H25.1376V58.9228H15.4263ZM9.54038 43.7532C7.24517 41.4163 5.81704 38.2107 5.81704 34.6846V15.2753C5.81704 11.7492 7.24517 8.54362 9.54038 6.20665C11.8458 3.88002 15.0081 2.44269 18.4866 2.44269H22.0773C25.5559 2.44269 28.7182 3.88002 31.0236 6.20665C33.3188 8.54362 34.7469 11.7492 34.7469 15.2753V34.6846C34.7469 38.2107 33.3188 41.4163 31.0236 43.7532C28.7182 46.0799 25.5559 47.5172 22.0773 47.5172H18.4866C15.0081 47.5172 11.8458 46.0799 9.54038 43.7532Z"
    />
    <path fill={accentColor} d="M22.1697 38.9844H18.4055V42.8H22.1697V38.9844Z" />
    <path
      fill="black"
      d="M29.4837 17.0227H28.7187C28.7187 19.3906 27.7802 21.5208 26.25 23.0719C24.7199 24.623 22.6185 25.5743 20.2825 25.5743C17.9465 25.5743 15.8451 24.623 14.3149 23.0719C12.7848 21.5208 11.8463 19.3906 11.8463 17.0227C11.8463 14.6547 12.7848 12.5245 14.3149 10.9734C15.8451 9.42234 17.9465 8.47101 20.2825 8.47101C22.6185 8.47101 24.7199 9.42234 26.25 10.9734C27.7802 12.5245 28.7187 14.6547 28.7187 17.0227H29.4837H30.2488C30.2488 11.4387 25.7808 6.91992 20.2825 6.91992C14.774 6.91992 10.3162 11.4387 10.3162 17.0227C10.3162 22.6066 14.7842 27.1254 20.2825 27.1254C25.791 27.1254 30.2488 22.5962 30.2488 17.0227H29.4837Z"
    />
    <path
      fill={accentColor}
      d="M23.1799 16.9396C23.1799 18.5631 21.8844 19.8764 20.2828 19.8764C18.6813 19.8764 17.3857 18.5631 17.3857 16.9396C17.3857 15.3162 18.6813 14.0029 20.2828 14.0029C21.8844 14.0029 23.1799 15.3265 23.1799 16.9396Z"
    />
  </DeviceIconSVG>
);

export default SecurityCamera;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/DeviceIcon/icons/SecurityCamera.tsx